var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.7324C9.5978 13.3866 10 12.7403 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 12.7403 6.4022 13.3866 7 13.7324V15C7 15.5523 7.44772 16 8 16C8.55228 16 9 15.5523 9 15V13.7324Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6V5C3 2.23858 5.23858 0 8 0C10.7614 0 13 2.23858 13 5V6C14.6569 6 16 7.34315 16 9V17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6ZM5 5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5V6H5V5ZM2 9C2 8.44772 2.44772 8 3 8H13C13.5523 8 14 8.44772 14 9V17C14 17.5523 13.5523 18 13 18H3C2.44772 18 2 17.5523 2 17V9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandlock);
export default __webpack_public_path__ + "static/media/pandlock.256aff980a87ccbb2919f75904577154.svg";
export { ForwardRef as ReactComponent };